export class ViewerUserSettings {
  alwaysFullScreen: boolean = false;
  alwaysHideBarcode: boolean = false;
  alwaysRotateImage: boolean = false;
  alwaysHideSlideList: boolean = false;
}
